<template>
  <div class="Home-area">
    <div class="banner-area">
      <swiper :options="swiperOption" class="swiper-container" ref="swiperBanner" v-if="bannerList.length > 0">
        <swiper-slide class="banner-slide" v-for="(banner, index) in bannerList" :key="index"><img :src="imgBaseUrl + banner" alt="wan " /></swiper-slide>
      </swiper>
    </div>
    <div class="abouts-area">
      <div class="container">
        <div class="area-lead">公司简介</div>
        <div class="cnt">
          万杰智能科技股份有限公司于1996年3月，注册资本7990万。 公司位于襄城县循环经济产业集聚区中西部，主要产品包括智能鲜面条机、智能熟面机、智能包子成型机和智能主食生产线等。
          企业占地面积130余亩，员工400余人...
        </div>
        <div class="video"><video-player class="video-player vjs-custom-skin" ref="videoPlayer" :options="playerOptions" :playsinline="true"></video-player></div>
      </div>
    </div>
    <div class="product-area">
      <div class="area-lead">系列产品</div>
      <div class="pro-list dis_flex flex_wrap">
        <router-link class="product" :to="{ path: '/productCenter', query: { typename: item.id } }" v-for="(item, index) in products" :key="index" v-if="index < 10">
          <div class="img"><img :src="item.product_class_img + '?x-oss-process=image/resize,h_270,w_270'" :alt="item.name" :title="item.name" /></div>
          <div class="title ellipsis">{{ item.name }}</div>
        </router-link>
      </div>
    </div>
    <div class="news-area">
      <div class="container">
        <div class="area-lead">最新资讯</div>
        <div class="new-list">
          <router-link :to="{ name: 'NewsDetail', params: { id: item.id } }" class="dis_flex new" v-for="(item, index) in newsList" :key="index">
            <div class="img"><img :src="item.article_img" :alt="item.title" :title="item.title" /></div>
            <div class="info">
              <div class="title ellipsis2">{{ item.title }}</div>
              <div class="time">{{ item.created_time }}</div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css';
import 'video.js/dist/video-js.css';
import '../../static/video.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import { videoPlayer } from 'vue-video-player';
export default {
  data() {
    return {
      videoCnt: {},
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        observeParents: true,
        observer: true
      },
      newsList: [],
      bannerList: [],
      products: [],
      imgBaseUrl: this.$imgBaseUrl,
      metaInfoAttr: {},
      playerOptions: {
        height: '390',
        muted: false,
        // playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: 'video/mp4',
            // mp4
            src: 'http://wxsmjphoto.wanjiejixie.com/wjsxy/zmj/00001.mp4'
          }
        ],
        poster: 'http://wxsmjphoto.wanjiejixie.com/guanwang/video-poster.png',
        language: 'zh-CN',
        fluid: true
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.swiperBanner.swiper;
    },
    player() {
      return this.$refs.videoPlayer.player;
    }
  },
  components: {
    swiper,
    swiperSlide,
    videoPlayer
  },
  mounted() {
    this.getBanner();
    this.getNews();
    this.getProduct();
    // this.$refs.videoPlayer.player.play()
  },
  methods: {
    getBanner: function() {
      // const _this = this
      this.$https
        .fetchPost('/api/getbanner', {})
        .then(res => {
          // console.log(res.data.data, JSON.parse(res.data.data.banner))
          this.bannerList = JSON.parse(res.data.data.banner);
          // this.$nextTick(() => {
          // _this.$refs.swiperBanner.swiper.init() // 再初始化swiper
          // })
        })
        .catch(err => {
          console.log(err);
        });
    },
    getNews: function() {
      this.$https
        .fetchPost('/Article/article_list', {
          limit: 6,
          is_recommend: 1
        })
        .then(res => {
          // console.log(res.data.data)
          this.newsList = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getProduct: function() {
      this.$https
        .fetchPost('/Product/product_class_list', {
          product_class_id: 2
        })
        .then(res => {
          // console.log(res.data)
          this.products = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style lang="less" scoped>
.Home-area {
  .banner-area {
    position: relative;
    max-height: 400px;
    overflow: hidden;
  }
  .area-lead {
    font-family: PingFang-SC-Bold;
    font-size: 34px;
    font-stretch: normal;
    line-height: 72px;
    letter-spacing: 0px;
    color: rgba(33, 33, 33, 1);
    text-align: center;
    font-weight: bold;
    margin-bottom: 30px;
  }
  .abouts-area {
    background: #ffffff;
    padding: 40px 0 80px;
    margin-bottom: 33px;
    .video {
      border-radius: 20px;
      width: 100%;
      overflow: hidden;
      margin-top: 30px;
    }
    .cnt {
      font-family: PingFang-SC-Medium;
      font-size: 28px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 44px;
      letter-spacing: 0.7px;
      color: rgba(48, 50, 69, 1);
      text-indent: 40px;
    }
  }
  .product-area {
    background-image: linear-gradient(0deg, rgba(244, 244, 244, 1) 0%, rgba(255, 255, 255, 1) 100%), linear-gradient(rgba(246, 246, 246, 1), rgba(246, 246, 246, 1));
    background-blend-mode: normal, normal;
    background-size: 100% 244px;
    background-repeat: no-repeat;
    padding: 37px 0;
    .product {
      width: 46.6667%;
      background-color: rgba(255, 255, 255, 1);
      border-radius: 10px;
      display: block;
      margin: 0 2.2% 18px;
      &:nth-child(2n) {
        margin-left: 0;
      }
      .img {
        width: 280px;
        height: 280px;
        margin: 5px auto;
      }
      .title {
        font-family: PingFang-SC-Medium;
        font-size: 30px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        line-height: 60px;
        color: rgba(48, 50, 69, 1);
        padding: 0 10%;
        text-align: center;
      }
    }
  }
  .news-area {
    background-image: linear-gradient(0deg, rgba(244, 244, 244, 1) 0%, rgba(255, 255, 255, 1) 100%), linear-gradient(rgba(246, 246, 246, 1), rgba(246, 246, 246, 1));
    background-blend-mode: normal, normal;
    background-size: 100% 244px;
    background-repeat: no-repeat;
    padding: 37px 0;
    .new-list {
      .new {
        width: 100%;
        background-color: rgba(255, 255, 255, 1);
        border-radius: 20px;
        padding: 30px;
        margin-bottom: 19px;
        .img {
          width: 245px;
          height: 140px;
          border-radius: 10px;
          overflow: hidden;
          img {
            width: 100%;
          }
        }
        .info {
          // width: 455px;
          flex: 1;
          padding-left: 20px;
          position: relative;
          .title {
            font-family: PingFang-SC-Medium;
            font-size: 28px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 40px;
            letter-spacing: 0px;
            color: rgba(55, 55, 55, 1);
            padding-bottom: 34px;
          }
          .time {
            font-family: PingFang-SC-Medium;
            font-size: 24px;
            line-height: 34px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: rgba(153, 153, 153, 1);
            position: absolute;
            bottom: 0;
            left: 20px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue